;(function() {
  'use strict'

  angular.module('glow.reporting', ['glow.reporting.charts'])
})()
